import QuizContentComponent from "../../../../../lib/html5-software-library/src/ranj/eng/content/QuizContentComponent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import DialogPlayerRegisterEvent from "../../../ngt/dialog/controller/DialogPlayerRegisterEvent";
import NGTDialogPlayerEvent from "../../../ngt/dialog/NGTDialogPlayerEvent";
import ScenarioPlayerEvent from "../../../ngt/scenario/ScenarioPlayerEvent";
import ComposerEvent from "../event/ComposerEvent";

export default class ComposerNavigateCommand extends AbstractCommand {
    constructor(dispatcher, dialogPlayer, dialogFactory) {
        super(dispatcher);
        this._dialogPlayer = dialogPlayer;
        this._dialogFactory = dialogFactory;
    }

    execute(evt) {
        const data = evt.params.data;

        /** @type {QuizContentComponent} */
        this._content = data.content;
        /** @type {NGTScenarioPlayer} */
        this._contentPlayer = data.contentPlayer;

        const dialogId = this._content.getQuizDialogID();
        const dialog = this._dialogFactory.getDialog(dialogId);
        this._dialogPlayer.setDialog(dialogId, dialog);

        this._composerScreen = this.openScreen(SkinKeyRegistry.COMPOSER_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            content: this._content,
            contentPlayer: this._contentPlayer,
            dialogPlayer: this._dialogPlayer
        });

        this._dispatcher.addEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound);
        this._dispatcher.addEventListener(NGTDialogPlayerEvent.DIALOG_ABORT, this._handleAbortDialogBound);

        this._dialogPlayer.viewContent();
    }

    _handleContentCompleted(evt) {
        const data = evt.params.data;
        /** @type {DecisionContent} */
        const content = data.content;

        if (content !== this._dialogPlayer.getContent()) {
            return;
        }

        this._closeContent();
        this.destroy();
    }

    _handleAbortDialog({ params }) {
        if (params.contentPlayer !== this._dialogPlayer) {
            return;
        }

        this._closeContent();
        this.destroy();
    }

    _closeContent() {
        this.closeScreen(this._composerScreen, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 350, createjs.Ease.sineInOut),
        });
    }
}